import React, { Component } from 'react';
import { Header, Table, Button, Modal } from 'semantic-ui-react'
import StockPaidCell from './StockPaidCell';
import { base, serverIp, toCurrency } from '../../../../config/constants';
import PrintingChargesStockPaidCell from './PrintingChargesStockPaidCell';


export function CostCell(props){

    const costCell = props.type === 'printingCharge'
    ? <Table.Cell >{toCurrency(props.order.shirtType.shirtTypeBuyCost)}</Table.Cell>
    : <Table.Cell >{toCurrency(props.order.shirtType.printingCharge)}</Table.Cell>

    return (
        <div>
            {costCell}
        </div>
    )
}


export function PaymentCell(props){
    console.log("stx21 +++++++:StockPaymentTable");
    console.log("stx22 type:"+props.type);

    const costCell = props.type === 'printingCharges'
    ?  <PrintingChargesStockPaidCell order={props.order} reloadOrders={props.reloadOrders} user={props.user} type={props.type} />
    :  <StockPaidCell order={props.order} reloadOrders={props.reloadOrders} user={props.user} type={props.type} />


    return (
        <div>
            {costCell}
        </div>
    )
}


export function StockPaymentTable(props) {
    console.log("stx1 +++++++:StockPaymentTable");
    console.log("stx12 type:"+props.type);
    const stockOrderTable = props.orders.map((order) =>

        <Table.Row>

            <Table.Cell>
                <Header as='h2' textAlign='center'>
                    {order.mainOrder.orderNum}
                </Header>
            </Table.Cell>
            <Table.Cell singleLine>{order.idinvidualOrders}</Table.Cell>
            <Table.Cell singleLine>{order.shirtType.shirtType}</Table.Cell>
            <Table.Cell singleLine><CostCell order={order} /></Table.Cell>
            
            <Table.Cell >{order.mainOrder.userz.name}</Table.Cell>
            <Table.Cell textAlign='center'>
                {/* <StockPaidCell order={order} reloadOrders={props.reloadOrders} user={props.user} type={props.type} /> */}
                <PaymentCell order={order} reloadOrders={props.reloadOrders} user={props.user} type={props.type} />
            </Table.Cell>
            <Table.Cell >{order.mainOrder.dateOrderDelivered}</Table.Cell>
            <Table.Cell>
                <a href={'https://printboda.com/dashboard/singleOrderView/' + order.order_num} target="_blank">VIEW ORDER</a>

            </Table.Cell>
        </Table.Row>

    )

    return (

        <div>
            <Table celled padded>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell singleLine>ORDER NUMBER</Table.HeaderCell>
                        <Table.HeaderCell>Indy Id</Table.HeaderCell>
                        <Table.HeaderCell>ITEM TYPE</Table.HeaderCell>
                        <Table.HeaderCell>COST</Table.HeaderCell>
                        <Table.HeaderCell>NAME</Table.HeaderCell>
                        <Table.HeaderCell>PAID</Table.HeaderCell>
                        <Table.HeaderCell>DATE DELIVERED</Table.HeaderCell>
                        <Table.HeaderCell>Comments</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {stockOrderTable}
                </Table.Body>
            </Table>

        </div>
    )
}

export function StockPaymentTablePython(props) {
    console.log("stx1 +++++++:StockPaymentTablePython");
    console.log("stx12 type:"+props.type);
    const stockOrderTable = props.orders.map((order) =>

        <Table.Row>

            <Table.Cell>
                <Header as='h2' textAlign='center'>
                    {order.reciepts_sent.order_num}
                </Header>
            </Table.Cell>
            <Table.Cell singleLine>{order.idreceiptitemlist}</Table.Cell>
            <Table.Cell singleLine>{order.shirttypes_sent.shirttype}</Table.Cell>
            {/* <Table.Cell singleLine><CostCell order={order} /></Table.Cell> */}
            <Table.Cell singleLine>{toCurrency(order.shirttypes_sent.shirttypebuycost)}</Table.Cell>
            
            <Table.Cell >{order.reciepts_sent.userz.name}</Table.Cell>
            {/* <Table.Cell textAlign='center'>
                <PaymentCell order={order} reloadOrders={props.reloadOrders} user={props.user} type={props.type} />
            </Table.Cell> */}
            <Table.Cell >{order.reciepts_sent.dadate}</Table.Cell>
            <Table.Cell>
                <a href={'https://printboda.com/dashboard/SingleOrderViewAlgolia/' + order.order_num} target="_blank">VIEW ORDER</a>
            </Table.Cell>
        </Table.Row>

    )

    return (

        <div>
            <Table celled padded>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell singleLine>ORDER NUMBER</Table.HeaderCell>
                        <Table.HeaderCell>ReceiptItemList Id</Table.HeaderCell>
                        <Table.HeaderCell>ITEM TYPE</Table.HeaderCell>
                        <Table.HeaderCell>COST</Table.HeaderCell>
                        <Table.HeaderCell>NAME</Table.HeaderCell>
                        {/* <Table.HeaderCell>PAID</Table.HeaderCell> */}
                        <Table.HeaderCell>DATE DELIVERED</Table.HeaderCell>
                        <Table.HeaderCell>Comments</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {stockOrderTable}
                </Table.Body>
            </Table>

        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/StockPaymentTable.js